import { render, staticRenderFns } from "./ResetPin.vue?vue&type=template&id=6ca17e13&v-on-clickaway=cancel&"
import script from "./ResetPin.vue?vue&type=script&lang=ts&"
export * from "./ResetPin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports